module.exports = __webpack_public_path__ + "static/media/nomos-logo.28387d9a.png";